// extracted by mini-css-extract-plugin
export default {"card":"styles_card__zIboD","value":"styles_value__U0D6j","arrowIcon":"styles_arrowIcon__uT8PI","description":"styles_description__fNvW1"};